import { createAppSlice } from '../../app/createAppSlice'

const initialState = {
    top: [],
    bottom: ["How to Cite", "Metadata", "Associated Resources", "JSON Outline"]
};

const navigationPanelSlice = createAppSlice({
    name: "navigationPanel",
    initialState,
    reducers: create => ({
        changeTopNavigationElements: create.reducer((state, action) => {
            state.top = action.payload
        }),
        changeBottomNavigationElements: create.reducer((state, action) => {
            state.bottom = action.payload
        }),
    }),
    selectors: {
        selectTopNavigationElements: navigationPanel => navigationPanel.top,
        selectBottomNavigationElements: navigationPanel => navigationPanel.bottom
    },
})

export const { changeTopNavigationElements, changeBottomNavigationElements } = navigationPanelSlice.actions

export const { selectTopNavigationElements, selectBottomNavigationElements } = navigationPanelSlice.selectors

export default navigationPanelSlice